export const languagesAvailable = {
  en: [
    { 0: 'English', isoCode: 'en' },
    { 1: 'Italian', isoCode: 'it' },
    { 2: 'Tagalog', isoCode: 'tl' },
  ],
  tl: [
    { 0: 'Ingles', isoCode: 'en' },
    { 1: 'Italyano', isoCode: 'it' },
    { 2: 'Tagalog', isoCode: 'tl' },
  ],
  it: [
    { 0: 'Inglese', isoCode: 'en' },
    { 1: 'Italiano', isoCode: 'it' },
    { 2: 'Tagalog', isoCode: 'tl' },
  ],
};
